import { render } from "./Evaluate.vue?vue&type=template&id=5b42780a&scoped=true"
import script from "./Evaluate.vue?vue&type=script&lang=js"
export * from "./Evaluate.vue?vue&type=script&lang=js"

import "./Evaluate.vue?vue&type=style&index=0&id=5b42780a&scoped=true&lang=css"

import exportComponent from "/home/tek2991/Desktop/Works/Projects/NEW_EPMS/avant-teacher-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b42780a"]])

export default __exports__